module.exports = __webpack_public_path__ + "img/wcsc.dae134e2.png";